/**
 * Places the next target before NextStep reads its geometry. Instant
 * scrolling avoids competing with the library's spotlight animation,
 * which otherwise follows a moving target and appears to bounce.
 */
export const scrollStepTargetIntoView = (selector: string | undefined): void => {
  if (!selector) {
    return;
  }

  const element = document.querySelector(selector);
  if (!element) {
    return;
  }

  const bounds = element.getBoundingClientRect();
  const viewportPadding = 24;
  const isVisible =
    bounds.top >= viewportPadding &&
    bounds.bottom <= window.innerHeight - viewportPadding &&
    bounds.left >= viewportPadding &&
    bounds.right <= window.innerWidth - viewportPadding;
  if (isVisible) {
    return;
  }

  element.scrollIntoView({
    behavior: "auto",
    block: "center",
    inline: "nearest",
  });
};
